<!--
  - Copyright (c) 2023-2024. Haodong JU
  -->

<template>
  <v-card color="grey lighten-4">
    <div
      v-if="!loading"
      :style="$vuetify.breakpoint.mobile ? 'grid-template-columns: repeat(1,minmax(0,1fr)' : ''"
      style="display: grid;grid-template-columns: repeat(2,minmax(0,1fr))"
    >
      <div class="pa-8 d-flex justify-center">
        <v-card
          class="d-flex align-center justify-center"
          color="grey lighten-3"
          elevation="0"
          height="200"
          style="border-radius: 150px !important;"
          width="200"
        >
          <div>
            <v-img
              :aspect-ratio="1"
              :src="product.images[0]"
              height="150"
              width="150"
            />
          </div>
        </v-card>
      </div>
      <v-card
        class="d-flex flex-column fill-height pa-4"
        elevation="0"
      >
        <div class="text-body-1 font-weight-bold">
          {{ product.name }}
        </div>
        <div
          v-if="product.metadata.type === 'hardware'"
          class="d-flex mt-2"
        >
          <div
            v-for="item in productTag"
            :key="item.id"
          >
            <v-chip
              class="mr-1 mb-1"
              color="green lighten-5"
              label
              small
            >
              {{ item }}
            </v-chip>
          </div>
        </div>
        <div class="text-body-2 text--secondary mt-2">
          {{ product.description || $t('no_description') }}
        </div>
        <div
          v-if="haveMaxCount"
          class="text-body-2 mt-2 text--secondary"
        >
          {{ $t('OrderUpTo') }} {{ maxCount }} {{ $t('Pice') }}
        </div>
        <v-spacer />
        <div
          v-if="!active"
          class="mt-1 text-body-2"
        >
          <stripe-price-display
            :count="count"
            :just-display="false"
            :price="product.prices"
            :price-type="oneTimeOrWhatever(product.prices)"
            @isYear="getPriceType"
          />
        </div>
        <div class="mt-4">
          <template v-if="!active">
            <div
              v-if="oneTime || product.metadata.type === 'extraDevice'"
              class="d-flex align-center"
            >
              <v-card

                class="d-flex align-center"
                color="grey lighten-4"
                elevation="0"
                style="border-radius: 48px !important;width: min-content"
              >
                <v-card
                  class="pa-3 d-flex align-center justify-center"
                  color="grey lighten-3"
                  elevation="0"
                  style="border-radius: 48px !important;"
                  @click="count-1>0?count--:count=1"
                >
                  <v-icon>mdi-minus</v-icon>
                </v-card>
                <div class="mx-4">
                  {{ count }}
                </div>
                <v-card
                  class="pa-3 d-flex align-center justify-center"
                  color="amber lighten-4"
                  elevation="0"
                  style="border-radius: 48px !important;"
                  @click="count+1>maxCount?count=maxCount:count++"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-card>
              </v-card>
              <v-spacer />
              <v-btn
                :loading="waitForJump"
                color="amber lighten-4 black--text"
                elevation="0"
                max-width="150"
                @click="purchaseProduct(code)"
              >
                <v-icon left>
                  mdi-basket
                </v-icon>
                {{ $t('BuyNow') }}
              </v-btn>
            </div>
            <template v-else>
              <div class="d-flex">
                <v-btn
                  :loading="waitForJump"
                  color="amber lighten-4 black--text"
                  elevation="0"
                  max-width="150"
                  @click="purchaseProduct(code)"
                >
                  <v-icon left>
                    mdi-basket
                  </v-icon>
                  {{ $t('OpenImmediately') }}
                </v-btn>
                <v-spacer />
                <v-btn
                  :loading="waitForJump"
                  class="ml-2"
                  color="info lighten-4 black--text"
                  elevation="0"
                  max-width="150"
                  @click="purchaseProduct(code,true)"
                >
                  <v-icon left>
                    mdi-progress-upload
                  </v-icon>
                  {{ $t('TryNow') }}
                </v-btn>
              </div>
            </template>
          </template>

          <div v-else-if="!oneTime&&appLink.length > 0">
            <div
              style="display: grid;grid-template-columns: repeat(2,1fr);grid-gap: 8px"
            >
              <v-btn
                v-for="item in realAppLink"
                :key="item.id"
                :loading="waitForJump"
                color="amber lighten-4 black--text"
                elevation="0"
                @click="gotoAppPage(item.url)"
              >
                {{ item.name }}
                <v-icon
                  right
                >
                  mdi-open-in-new
                </v-icon>
              </v-btn>
            </div>
          </div>

          <template v-else-if="code === 'scanToOrder'">
            <v-btn
              v-if="subdomainName"
              :loading="downLoading"
              color="amber lighten-4 black--text"
              elevation="0"
              @click="downloadQR"
            >
              {{ $t('DownloadQR') }}
              <v-icon
                right
              >
                mdi-qrcode
              </v-icon>
            </v-btn>
            <v-btn
              v-else
              color="amber lighten-4 black--text"
              elevation="0"
              @click="registerQr = true"
            >
              {{ $t('QrRegister') }}
              <v-icon
                right
              >
                mdi-qrcode
              </v-icon>
            </v-btn>
          </template>
        </div>
      </v-card>
    </div>
    <div
      v-else
      class="d-flex align-center justify-center"
      style="min-height: 300px"
    >
      <v-progress-circular indeterminate />
    </div>
    <v-dialog
      v-model="registerQr"
      max-width="400px"
    >
      <v-card class="pa-4">
        <div class="d-flex align-center justify-center">
          <div class="text-body-1 font-weight-bold">
            {{ $t('RegisterDomain') }}
          </div>
          <v-spacer />
          <div>
            <v-btn
              icon
              @click="registerQr = false"
            >
              <v-icon>
                mdi-close
              </v-icon>
            </v-btn>
          </div>
        </div>
        <div class="text-body-2 mt-1">
          {{ $t('AddDomainName') }}
        </div>
        <div class="mt-4">
          <v-text-field
            v-model="qrSubdomainName"
            :prefix="locationProtocol"
            :rules="hostRules"
            outlined
            required
            suffix=".qr.aaden.io"
          />
        </div>
        <div class="mt-4 d-flex align-center justify-center">
          <v-spacer />
          <v-btn
            :disabled="existDomainname"
            :loading="qrRegisterLoading"
            class="mr-2"
            color="amber lighten-4 black--text"
            elevation="0"
            @click="getQrSubdomainName"
          >
            {{ $t('Register') }}
            <v-icon right>
              mdi-arrow-right
            </v-icon>
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapMutations } from 'vuex'
import GlobalSettings from '@/model/global/GlobalSettings'
import JSZip from 'jszip'
import FileSaver from 'file-saver'
import StripePriceDisplay from '@/views/widget/commonLogic/StripePriceDisplay.vue'
import { loadProducts, ProductCodes } from '@/model/dataLayer/api/SaaS/product'
import { getActiveProductCode, getCurrentStoreId, getUserCurrentStoreInfo } from '@/model/dataLayer/api/SaaS/user'
import { setRecords } from '@/model/dataLayer/api/takeaway/TakeawayManager'
import Table from '@/model/dataLayer/api/tableAndPerson/Table'
import { checkNewRecords, checkOldRecords } from '@/model/firebase/takewayCompat'
import { addProduct } from '@/views/SaaS/SaaSGuide'
import IKUtils from 'innerken-js-utils'
import { checkTrialCode, doPayment } from '@/model/dataLayer/api/SaaS/SaaSUtils'

export default {
  name: 'ProductDetail',
  components: {
    StripePriceDisplay
  },
  props: {
    SaaSGuide: {},
    code: {}
  },
  data: function () {
    return {
      isYear: true,
      allRecordsSubdomainName: '',
      qrRegisterLoading: false,
      qrSubdomainName: '',
      hostRules: [
        v => !!v || this.$t('hostCantEmpty'),
        v => !this.allRecordsSubdomainName.includes(v) ||
            this.$t('thisHostnameAlreadyUse')
      ],
      registerQr: false,
      subdomainName: '',
      downLoading: false,
      loading: true,
      waitForJump: false,
      count: 1,
      products: [],
      enProducts: [],
      activeProductCodeList: []
    }
  },
  computed: {
    existDomainname () {
      return this.allRecordsSubdomainName.includes(this.qrSubdomainName)
    },
    locationProtocol () {
      return location.protocol + '//'
    },
    oneTime () {
      return this.product.prices[0].type === 'one_time'
    },
    type () {
      return this.product.metadata.type
    },
    realAppLink () {
      // v1普遍 v2特殊
      console.log(this.appLink, 'link')
      if (!this.activeProductCodeList.includes(ProductCodes.restaurant)) {
        return this.appLink.filter(it => it.value === 'v1')
      } else {
        return this.appLink
      }
    },
    appLink () {
      if (this.product.metadata.appLink) {
        return this.product.metadata?.appLink.split(',').map(it => {
          const x = it.split('_')
          return {
            value: x[0],
            name: x[1],
            url: document.location.protocol + '//' + x[2] + '/?Base=' + GlobalSettings.DeviceId
          }
        })
      } else {
        return false
      }
    },
    haveMaxCount () {
      return this.product.metadata.maxCount
    },
    maxCount () {
      return this.product.metadata?.maxCount ?? 1
    },
    product () {
      return this.products.find(it => it.metadata.code === this.code)
    },
    enProduct () {
      return this.enProducts.find(it => it.metadata.code === this.code)
    },
    active () {
      return this.activeProductCodeList.includes(this.code)
    },
    productTag () {
      let tagList = []
      tagList = this.product.metadata.tag.split(',')
      return tagList
    }
  },
  watch: {
    code () {
      this.count = 1
    }
  },
  async mounted () {
    this.loading = true
    this.products = (await loadProducts())
    this.enProducts = (await loadProducts(1))
    this.activeProductCodeList = await getActiveProductCode()
    await this.reloadSubInfo()
    this.loading = false
  },
  methods: {
    getPriceType (type) {
      this.isYear = type
    },
    async getQrSubdomainName () {
      this.qrRegisterLoading = true
      await setRecords(
        this.qrSubdomainName,
        '',
        '',
        '',
        '',
        '')
      this.qrRegisterLoading = false
      this.registerQr = false
      await this.reloadSubInfo()
    },
    async reloadSubInfo () {
      this.loading = true
      const storeId = await getCurrentStoreId()
      const newRecords = (await checkNewRecords())
      const oldRecords = (await checkOldRecords())
      const allRecords = newRecords.concat(oldRecords)
      this.allRecordsSubdomainName = allRecords.map(it => it.subdomainName)
      this.subdomainName = allRecords.find(it => it.deviceId.toString() === storeId?.toString())?.subdomainName ?? ''
      this.loading = false
    },
    async downloadQR () {
      this.downLoading = true
      const tableList = await Table.getList(true)
      const QRCodeHeader = 'https://api.qrserver.com/v1/create-qr-code/?size=260x260&data='
      const urlList = []
      tableList.forEach(it => {
        const tableQrUrl = QRCodeHeader + location.protocol + '//' + this.subdomainName + '.qr.aaden.io/?tableName=' + it.name
        urlList.push({
          url: tableQrUrl,
          name: it.name
        })
      })
      const zip = new JSZip()
      const img = zip.folder('images')
      for (const item of urlList) {
        img.file(`${item.name}.png`, (await fetch(item.url)).blob())
      }
      zip.generateAsync({ type: 'blob' })
        .then(function (content) {
          FileSaver.saveAs(content, 'QRCode.zip')
        })
      this.downLoading = false
    },
    ...mapMutations(['showProductPage', 'closeProductDetail']),
    oneTimeOrWhatever (prices) {
      if (prices[0].type === 'one_time') {
        return 'one_time'
      } else {
        return 'recurring'
      }
    },
    async purchaseProduct (code, useTrial = false) {
      this.waitForJump = true
      if (!this.isYear && this.enProduct.prices[0].type !== 'one_time') {
        this.enProduct.realPrice = this.enProduct.prices.find(it => it.interval === 'month')
      }
      if (this.SaaSGuide === 1) {
        this.enProduct.count = this.count
        await addProduct(this.enProduct)
        this.closeProductDetail()
        this.$store.state.SaaSCallback()
      } else {
        try {
          let currentStoreId = null
          const notBindCodes = [ProductCodes.oldDevice, ProductCodes.base, ProductCodes.extraStore]
          if (!notBindCodes.includes(this.enProduct.metadata.code)) {
            currentStoreId = (await getUserCurrentStoreInfo())?.currentStoreId
          }
          if (useTrial) {
            this.closeProductDetail()
            const trialDate = await checkTrialCode([this.enProduct.metadata.code])
            if (trialDate) {
              IKUtils.showLoading(true)
              const session = await doPayment([
                {
                  ...this.enProduct,
                  count: this.count
                }
              ], currentStoreId, trialDate)
              if (session) {
                location.reload()
              }
            } else {
              IKUtils.showError(this.$t('WrongTrailCode'))
            }
          } else {
            const session = await doPayment([
              {
                ...this.enProduct,
                count: this.count
              }
            ], currentStoreId)
            if (session) {
              location.reload()
            }
          }
        } catch (e) {
          console.log(e)
        }
      }

      this.waitForJump = false
    },
    gotoAppPage (link) {
      console.log(link, 'link')
      this.showProductPage(link)
    }
  }
}
</script>

<style scoped>

</style>
